import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { useQueryData } from 'LoginUI/hooks/useQueryData';
import { redirectToSanitizedHubSpotUrl } from 'LoginUI/utils/redirectToSanitizedHubSpotUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyLandingPageComponent = () => {
  const {
    allQueryParams
  } = useQueryData();
  const otpPage = allQueryParams.otpPage;
  useEffect(() => {
    redirectToSanitizedHubSpotUrl(otpPage, {
      decode: false
    });
  }, [otpPage]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(NavMarker, {
      name: "OTP_LANDING_PAGE_LOAD"
    })
  });
};
export default EmptyLandingPageComponent;